import { POS_VISITOR, POS_CUSTOMER } from 'src/consts/third_party';
class IntercomClass {
  constructor({ intercomAppId, initedCallback }) {
    this.intercomAppId = intercomAppId;
    this.initedCallback = initedCallback;
    this.intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: intercomAppId,
      hide_default_launcher: false,
    };
    this.init();
  }

  init() {
    this.initIntercom();
  }

  initIntercom() {
    let _this = this;
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', _this.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + _this.intercomAppId;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
        s.onload = s.onreadystatechange = function () {
          if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
            // _this.initedCallback && _this.initedCallback();
            intercomManager.showMessager && _this.initedCallback && _this.initedCallback();
          }
        };
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  }

  shutdown() {
    window.Intercom && window.Intercom('shutdown');
  }

  sendBoot({ userType, info }) {
    console.log('准备发送消息', intercomManager.showMessager, window.Intercom);
    if (!intercomManager.showMessager) return;
    let params = {
      app_id: this.intercomAppId,
      'User Type': userType,
    };
    switch (userType) {
      case POS_VISITOR: {
        if (info) {
          const { id, email, created_at, first_name, last_name, hmac_digest } = info;
          params = {
            ...params,
            user_id: id,
            name: [first_name, last_name].join(' '),
            email,
            user_hash: hmac_digest,
            created_at,
            'Profile Page': `https://api.chowbus.com/backend/users/${id}`,
          };
        }
        break;
      }
      case POS_CUSTOMER: {
        if (info) {
          const { restaurant_id, serial_number, employee_id = '', restaurant_name = '', user_hash } = info;
          params = {
            ...params,
            restaurantid: restaurant_id,
            serialnumber: serial_number,
            employeeid: employee_id,
            company: {
              id: restaurant_id,
              name: restaurant_name,
            },
            user_id: employee_id,
            user_hash,
          };
        }
        window.Intercom('show');
        break;
      }
    }
    window.Intercom('boot', params);
    console.log('已经发送消息', intercomManager.showMessager, window.Intercom);
  }
}

export const intercomManager = {
  intercomMap: {},
  initIntercom({ intercomAppId, initedCallback }) {
    if (this.intercomMap[intercomAppId]) return initedCallback();
    this.intercomMap[intercomAppId] = new IntercomClass({ intercomAppId, initedCallback });
  },
  getById(intercomAppId) {
    return this.intercomMap[intercomAppId];
  },
  showMessager: false,
  setShowMessage(shouldShow) {
    this.showMessager = shouldShow;
  },
};
